<template lang="pug">
    v-layout.wf-justify-content-center(row wrap)
        v-flex(xs12)
            Navbar(:noBackChevron="true")
        v-flex(xs12 lg4 mx-2)
            fan-loader(
                :loading="true"
            )
                div(slot="loadingMsg"
                class="full-width text-xs-center headline my-2") Redirecting to {{ this.lender }}...
</template>

<script>
    import Navbar from 'Components/Navbar.vue'
    import FanLoader from 'Components/FanLoader.vue'
    import { mapState } from 'vuex'

export default {
    components: {
      FanLoader,
      Navbar,
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender.nickName,
      })
    },
}
</script>
